import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isEdit: false,
  createForm: { name: "", engName: "" },
  updateForm: { id: "", name: "", engName: "" },
  betOptionId: "",
  optionCreateForm: {
    name: "",
    engName: "",
    profit: 0,
    isHaveProfit: false,
  },
  optionUpdateForm: {
    id: "",
    name: "",
    engName: "",
    profit: 0,
    betOptionId: "",
    isHaveProfit: false,
  },
  isOpenModal: false,
  isOpenOptionModal: false,
};

const betOptionSlice = createSlice({
  name: "betOption",
  initialState,
  reducers: {
    setUpdateBetOption: (state, { payload }) => {
      state.isEdit = true;
      state.updateForm = {
        id: payload.id,
        name: payload.name,
        engName: payload.engName,
        profit: payload.profit,
      };
    },
    onChangeBetOption: (state, { payload }) => {
      if (state.isEdit) {
        state.updateForm = {
          ...state.updateForm,
          name: payload.name,
          engName: payload.engName,
        };
      } else {
        state.createForm = {
          ...state.createForm,
          name: payload.name,
          engName: payload.engName,
        };
      }
    },
    clearFormBetOption: (state) => {
      state.isEdit = initialState.isEdit;
      state.createForm = initialState.createForm;
      state.updateForm = initialState.updateForm;
    },
    toggleBetOptionModal: (state) => {
      state.isOpenModal = !state.isOpenModal;
    },
    setBetOptionId: (state, { payload }) => {
      state.optionCreateForm.betOptionId = payload;
    },
    toggleOptionModal: (state, { payload }) => {
      if (payload === true) {
        state.optionCreateForm = initialState.optionCreateForm;
        state.optionUpdateForm = initialState.optionUpdateForm;
      }
      state.isOpenOptionModal = !state.isOpenOptionModal;
    },
    setUpdateOption: (state, { payload }) => {
      state.isEdit = true;
      state.optionUpdateForm = {
        id: payload.id,
        name: payload.name,
        engName: payload.engName,
        profit: payload.profit,
        isHaveProfit: payload.isHaveProfit,
      };
    },
    clearFormOption: (state) => {
      state.isEdit = initialState.isEdit;
      state.optionCreateForm = initialState.optionCreateForm;
      state.optionUpdateForm = initialState.optionUpdateForm;
    },
    onChangeOptionForm: (state, { payload }) => {
      if (state.isEdit) {
        state.optionUpdateForm = {
          ...state.optionUpdateForm,
          name: payload.name,
          engName: payload.engName,
          profit: payload.profit,
        };
      } else {
        state.optionCreateForm = {
          ...state.optionCreateForm,
          name: payload.name,
          engName: payload.engName,
          profit: payload.profit,
        };
      }
    },
    clearBetOption: () => initialState,
  },
});

export const {
  setUpdateBetOption,
  onChangeBetOption,
  clearFormBetOption,
  clearBetOption,
  toggleBetOptionModal,
  setBetOptionId,
  toggleOptionModal,
  setUpdateOption,
  clearFormOption,
  onChangeOptionForm,
} = betOptionSlice.actions;

export default betOptionSlice.reducer;
